export default __webpack_public_path__ + "static/media/Strangler's Cord of Waning Dusk.b5220b58.jpg";